<div class="py-8 px-6 gap-4 align-items-stretch">
  <div class="row">
    <div class="col-2">
      <label>{{ 'ACCOUNT.LASTNAME' | translate }}</label>
      <span>{{ form.lastname().value() }}</span>
    </div>
    <div class="col-2">
      <label>{{ 'ACCOUNT.FIRSTNAME' | translate }}</label>
      <span>{{ form.firstname().value() }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <label>{{ 'ACCOUNT.MAIL' | translate }}</label>
      <span>{{ form.email().value() }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <label>{{ 'ACCOUNT.DEFAULT_LANGUAGE' | translate }}</label>
      <span>{{ 'COMMON.LANGUAGE.' + language | translate: { default: '-' } }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <vitamui-slide-toggle class="fields-padding" [formField]="form.otp">{{ 'ACCOUNT.OTP_AUTH' | translate }} </vitamui-slide-toggle>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <label>{{ 'ACCOUNT.PHONE.MOBILE' | translate }}</label>
      <span>{{ form.mobile().value() }}</span>
    </div>

    <div class="col-2">
      <label>{{ 'ACCOUNT.PHONE.FIX' | translate }}</label>
      <span>{{ form.phone().value() }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      <label>{{ 'ACCOUNT.DELIVERY_ADRESS' | translate }}</label>
      @if (form.address().value()?.street) {
        <span
          >{{ form.address().value()?.street }}
          @if (form.address().value()?.city && form.address().value()?.zipCode) {
            <span>,</span>
          }
        </span>
      }
      @if (form.address().value()?.city && form.address().value()?.zipCode) {
        <span> {{ form.address().value()?.zipCode }}, {{ form.address().value()?.city }} </span>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <label>{{ 'ACCOUNT.LEVEL' | translate }}</label>
      <span>{{ form.level().value() }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      <label>{{ 'ACCOUNT.GROUP' | translate }}</label>
      <span>{{ form.profileGroup().value()?.name }}</span>
      <span>{{ form.profileGroup().value()?.description }}</span>
    </div>
  </div>
</div>
